export default __webpack_public_path__ + "static/media/MaskGroup.9d398dbb.png";